// Utilitário para persistência e recuperação de parâmetros UTM
const UTM_KEY = "persisted_utm_params";
const UTM_EXPIRY_KEY = "persisted_utm_expiry";
const UTM_EXPIRY_DAYS = 30; // Expira após 30 dias

// Salva os parâmetros UTM no localStorage com data de expiração
export function persistUtmParamsFromUrl() {
	if (typeof window === "undefined") return;

	const urlParams = new URLSearchParams(window.location.search);

	// Verifica se há algum parâmetro UTM na URL
	const hasUtm = Array.from(urlParams.keys()).some((key) =>
		key.startsWith("utm_"),
	);

	if (hasUtm) {
		// Recupera UTMs existentes
		const existingUtms = getPersistedUtmParams();
		const existingParams = new URLSearchParams(existingUtms);

		// Merge dos novos UTMs com os existentes (novos têm prioridade)
		const mergedParams = new URLSearchParams();

		// Adiciona UTMs existentes primeiro
		for (const [key, value] of existingParams) {
			if (key.startsWith("utm_")) {
				mergedParams.set(key, value);
			}
		}

		// Sobrescreve com novos UTMs da URL atual
		for (const [key, value] of urlParams) {
			if (key.startsWith("utm_")) {
				mergedParams.set(key, value);
			}
		}

		// Salva os parâmetros UTM merged
		localStorage.setItem(UTM_KEY, mergedParams.toString());

		// Salva a data de expiração (30 dias a partir de agora)
		const expiryDate = new Date();
		expiryDate.setDate(expiryDate.getDate() + UTM_EXPIRY_DAYS);
		localStorage.setItem(UTM_EXPIRY_KEY, expiryDate.toISOString());

		console.log("UTM params persistidos:", mergedParams.toString());
	}
}

// Recupera os parâmetros UTM persistidos (se não expiraram)
export function getPersistedUtmParams(): string {
	if (typeof window === "undefined") return "";

	const utmParams = localStorage.getItem(UTM_KEY);
	const expiryDate = localStorage.getItem(UTM_EXPIRY_KEY);

	// Se não existir parâmetros UTM salvos, retorna string vazia
	if (!utmParams) return "";

	// Verifica se os parâmetros expiraram
	if (expiryDate) {
		const expiry = new Date(expiryDate);
		const now = new Date();

		if (now > expiry) {
			// Parâmetros expiraram, limpa o localStorage
			clearPersistedUtmParams();
			return "";
		}
	}

	return utmParams;
}

// Limpa os parâmetros UTM persistidos
export function clearPersistedUtmParams() {
	if (typeof window === "undefined") return;

	localStorage.removeItem(UTM_KEY);
	localStorage.removeItem(UTM_EXPIRY_KEY);
	console.log("UTM params limpos do localStorage");
}
